import { FC, useCallback, useRef } from 'react';
import { StoryType } from '@edikk-edikk/country-common';
import {
  StoryItemList,
  StoryDetailListWrapperType,
  StoryDetailListWrapper,
} from '@edikk-edikk/country-layout-black-story';

type PropsType = {
  storyDataList: StoryType[];
};

const StoryList: FC<PropsType> = ({
  storyDataList,
}) => {
  const refStoryDetailListWrapper = useRef<StoryDetailListWrapperType>(null);

  const handlerClickOnStory = useCallback((story: StoryType) => {
    refStoryDetailListWrapper.current.open(story.id);
  }, []);

  if (storyDataList.length === 0) {
    return null;
  }

  return (
    <>
      <StoryItemList storyList={storyDataList} onClickOnStory={handlerClickOnStory} />
      <StoryDetailListWrapper storyList={storyDataList} ref={refStoryDetailListWrapper} />
    </>
  );
};

export { StoryList };
